export default "__VITE_ASSET__DqOL$lIr__"